import EstablishmentRelationship from "./EstablishmentRelationship";

export default EstablishmentRelationship;
